module.exports = __webpack_public_path__ + "static/media/something_turquoise-IG.14d45a63.PNG";